import React from 'react'
import { SBDatePicker } from '../../../../UiComponents/SBDatePicker'
import { SBAComboBox } from '../../../../UiComponents/SBADropDown'
import { AgGridReact } from 'ag-grid-react'

export const Revenue = () => {
  const columnDefs = [
    { headerName: "Client Billing Name", field: "ClientBillingName" },
    { headerName: "Starting AUM", field: "StartingAUM" },
    { headerName: "Total Flows", field: "TotalFlows" },
    { headerName: "First Month Flows", field: "FirstMonthFlows" },
    { headerName: "Second Month Flows", field: "SecondMonthFlows" },
    { headerName: "Third Month Flows", field: "ThirdMonthFlows" },
    { headerName: "Revenue", field: "Revenue" },
    { headerName: "Run Rate", field: "RunRate" },
    { headerName: "Bill Rate", field: "BillRate" },
    { headerName: "Balance", field: "Balance" },
    { headerName: "PNL", field: "PNL" },
    { headerName: "Ending AUM", field: "EndingAUM" },
  ];
  const defaultColumnDef={flex:1,autoHeaderHeight: true,wrapHeaderText: true,resizable: true,};
  return (
    <>
    <div className='row'>
       <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Report Date</label>
            <div>
            <SBDatePicker />
            </div>
          </div>

        </div>
    </div>
     <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
     <AgGridReact columnDefs={columnDefs} rowData={[]} defaultColDef={defaultColumnDef}></AgGridReact>
   </div></>
  )
}
